import * as Common from '@/agiles/common';

export class UsageQuery extends Common.Query {
    constructor(countType:UsageCountType){
        super('UsageQuery',new Common.ModelBinder(UsageQueryResult,false));
        this.countType = countType;
    }
    public  countType:UsageCountType;
}

export class UsageQueryResult extends Common.ObjectBase {
    constructor(){
      super('UsageQueryResult');
      this.binders.counters = new Common.ModelBinder(UsageCounter,true);
      this.binders.steps = new Common.ModelBinder(RoadmapStep,true);
    }
    public counters : UsageCounter[];
    public steps :RoadmapStep[];

    public isPreparationCompleted: boolean;
    public get completed(){
        return this.counters.filter(obj =>obj.isPreparation == !this.isPreparationCompleted).filter(obj =>obj.isCompleted).length;
    }
    public get total(){
        return this.counters.filter(obj =>obj.isPreparation == !this.isPreparationCompleted).length;
    }    
    public get completedRatio() {
        return Math.floor(this.completed/this.total * 100);
    }    
}

export class UsageCounter extends Common.ObjectBase {
    constructor(){
      super('UsageCounter');          
    }    
        public name :string;
        public goal :number;
        public count :number;
        public roadmapFlag :RoadmapFlags;
        public isCompleted :boolean;
        public isPreparation:boolean;
}

export class RoadmapStep extends Common.ObjectBase {
    constructor(){
      super('RoadmapStep');          
    }    
    public flag :RoadmapFlags;
    public voucherNo :string;
    public isSourceVoucher:boolean;
    public hasSample:boolean;

    public get index():string {

        if (this.flag == RoadmapFlags.Commodity) return '1';
        else if (this.flag ==RoadmapFlags.Customer) return '2';
        else if (this.flag ==RoadmapFlags.Supplier) return '3';
        else if (this.flag ==RoadmapFlags.Warehouse) return '4';              
        else if (this.flag ==RoadmapFlags.Segment) return '5';
        else if (this.flag ==RoadmapFlags.BankAccount) return '6';                                  
        else if (this.flag ==(RoadmapFlags.SalesOrder | RoadmapFlags.PurchaseOrder)) return '1/2';
        else if (this.flag ==RoadmapFlags.SalesOrder) return '1/2';
        else if (this.flag ==RoadmapFlags.PurchaseOrder) return '1/2';
        else if (this.flag ==RoadmapFlags.PurchaseDelivery) return '3';
        else if (this.flag ==RoadmapFlags.SalesDelivery) return '4';
        else if (this.flag ==RoadmapFlags.SalesPost) return '5';        
        else if (this.flag ==RoadmapFlags.SalesPayment) return '6';   
        else if (this.flag ==RoadmapFlags.PurchasePost) return '7';    
        else if (this.flag ==RoadmapFlags.PurchasePayment) return '8';        

        // if (this.hasSample){
        //     if (this.flag == RoadmapFlags.Commodity) return '1';
        //     else if (this.flag ==RoadmapFlags.Customer) return '2';
        //     else if (this.flag ==(RoadmapFlags.SalesOrder | RoadmapFlags.PurchaseOrder)) return '3/4';
        //     else if (this.flag ==RoadmapFlags.SalesOrder) return '3/4';
        //     else if (this.flag ==RoadmapFlags.PurchaseOrder) return '3/4';
        //     else if (this.flag ==RoadmapFlags.PurchaseDelivery) return '5';
        //     else if (this.flag ==RoadmapFlags.SalesDelivery) return '6';
        //     else if (this.flag ==RoadmapFlags.SalesPost) return '7';        
        //     else if (this.flag ==RoadmapFlags.SalesPayment) return '8';   
        //     else if (this.flag ==RoadmapFlags.PurchasePost) return '9';    
        //     else if (this.flag ==RoadmapFlags.PurchasePayment) return '10';
        // } else {
        //     if (this.flag == RoadmapFlags.Commodity) return '1';
        //     else if (this.flag ==RoadmapFlags.Customer) return '2';
        //     else if (this.flag ==RoadmapFlags.Supplier) return '3';
        //     else if (this.flag ==RoadmapFlags.Warehouse) return '4';              
        //     else if (this.flag ==RoadmapFlags.Segment) return '5';
        //     else if (this.flag ==RoadmapFlags.BankAccount) return '6';                                  
        //     else if (this.flag ==(RoadmapFlags.SalesOrder | RoadmapFlags.PurchaseOrder)) return '7/8';
        //     else if (this.flag ==RoadmapFlags.SalesOrder) return '7/8';
        //     else if (this.flag ==RoadmapFlags.PurchaseOrder) return '7/8';
        //     else if (this.flag ==RoadmapFlags.PurchaseDelivery) return '9';
        //     else if (this.flag ==RoadmapFlags.SalesDelivery) return '10';
        //     else if (this.flag ==RoadmapFlags.SalesPost) return '11';        
        //     else if (this.flag ==RoadmapFlags.SalesPayment) return '12';   
        //     else if (this.flag ==RoadmapFlags.PurchasePost) return '13';    
        //     else if (this.flag ==RoadmapFlags.PurchasePayment) return '14';            
        // }


    }
    public get url():string {
       if (this.flag == RoadmapFlags.Commodity && this.isSourceVoucher) return '/master/Commodity'; 
       else if (this.flag == RoadmapFlags.Commodity && this.isSourceVoucher == false) return '/master/Commodity?auditNo=' + this.voucherNo; 
       else if ((this.flag == RoadmapFlags.Customer  || this.flag == RoadmapFlags.Supplier || this.flag == RoadmapFlags.Warehouse) && this.isSourceVoucher) return '/master/Counterpart'; 
       else if ((this.flag == RoadmapFlags.Customer  || this.flag == RoadmapFlags.Supplier || this.flag == RoadmapFlags.Warehouse) && this.isSourceVoucher == false) return '/master/Counterpart?auditNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.Segment && this.isSourceVoucher) return '/master/Segment'; 
       else if (this.flag == RoadmapFlags.Segment && this.isSourceVoucher == false) return '/master/Segment?auditNo=' + this.voucherNo;        
       else if (this.flag == RoadmapFlags.BankAccount && this.isSourceVoucher) return '/master/BankAccount'; 
       else if (this.flag == RoadmapFlags.BankAccount && this.isSourceVoucher == false) return '/master/BankAccount?auditNo=' + this.voucherNo;             
       else if (this.flag == (RoadmapFlags.SalesOrder | RoadmapFlags.PurchaseOrder) && this.isSourceVoucher) return '/sales/SalesOrder'; 
       else if (this.flag == (RoadmapFlags.SalesOrder | RoadmapFlags.PurchaseOrder) && this.isSourceVoucher == false) return '/sales/SalesOrder'; 
       else if (this.flag == RoadmapFlags.SalesOrder && this.isSourceVoucher) return '/sales/SalesOrder'; 
       else if (this.flag == RoadmapFlags.SalesOrder && this.isSourceVoucher == false) return '/sales/SalesOrder?orderNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.SalesDelivery && this.isSourceVoucher) return '/sales/SalesOrder?orderNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.SalesDelivery && this.isSourceVoucher == false) return '/sales/SalesDelivery?deliveryNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.SalesPost && this.isSourceVoucher) return '/sales/SalesDelivery?deliveryNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.SalesPost && this.isSourceVoucher == false) return '/sales/AloneInvoice?invoiceNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.SalesPayment && this.isSourceVoucher) return '/sales/AloneInvoice?invoiceNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.SalesPayment && this.isSourceVoucher == false) return '/cash/Deposit?paymentNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.PurchaseOrder && this.isSourceVoucher) return '/sales/SalesOrder?orderNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.PurchaseOrder && this.isSourceVoucher == false) return '/purchase/PurchaseOrder?orderNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.PurchaseDelivery && this.isSourceVoucher) return '/purchase/PurchaseOrder?orderNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.PurchaseDelivery && this.isSourceVoucher == false) return '/purchase/PurchaseDelivery?deliveryNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.PurchasePost && this.isSourceVoucher) return '/purchase/PurchaseInvoice?invoiceNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.PurchasePost && this.isSourceVoucher == false) return '/purchase/PurchaseInvoice?invoiceNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.PurchasePayment && this.isSourceVoucher) return '/purchase/PurchaseInvoice?invoiceNo=' + this.voucherNo; 
       else if (this.flag == RoadmapFlags.PurchasePayment && this.isSourceVoucher == false) return '/cash/WithDrawal?paymentNo=' + this.voucherNo; 
       
       return '';
    }
}

export enum RoadmapFlags{
        Default = 0,        
        SalesOrder = 1,
        SalesDelivery = 2,
        SalesPost = 4,
        SalesPayment = 8,    
        PurchaseOrder = 16,
        PurchaseDelivery = 32,
        PurchasePost = 64,
        PurchasePayment = 128,
        Commodity = 256,
        Customer = 512,    
        Supplier = Customer * 2,
        Warehouse = Supplier * 2,     
        Segment = Warehouse * 2,
        BankAccount = Segment * 2,
}
export enum UsageCountType
{
    Default,
    PreviousMonth,
    CurrentMonth
}